import { render, staticRenderFns } from "./DynamicOnboarding.vue?vue&type=template&id=a1be62ea&scoped=true"
import script from "./DynamicOnboarding.vue?vue&type=script&lang=js"
export * from "./DynamicOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1be62ea",
  null
  
)

export default component.exports